
/**
 * Provide loose pub/sub functionality
 * @class Observable
 */
class Observable {

    constructor() {
        this.observers = [];
    }

	/**
	 * Register listener
	 * @param  {function} listener
	 */
    observe(listener) {
        this.observers.push(listener);
    }

	/**
	 * Unregister listener
	 * @param  {function} unsubscribeMe
	 */
    unsubscribe(unsubscribeMe) {
        this.observers = this.observers.filter(listener => unsubscribeMe !== listener ? listener : null);
    }

    /**
     * notify loose set of arguments to observers]
     * @return {[type]}
     */
    notify() {
        for (const i in this.observers) {
            if (this.observers.hasOwnProperty(i)) {
                this.observers[i].apply(window, arguments);
            }
        }
    }
}

export default Observable;
